import '../../../../Styles/Toyota.scss'

import React from 'react';
import axios from 'axios';

import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'

import Image from 'react-bootstrap/Image';
import ResendLink from '../..//Shared/ResendLink';
import ToyotaLogo from '../../../../static/images/Toyota-Logo.svg'
import Loader from '../../../../static/images/loading.gif'
import AppVars from '../../../../AppVars.js'
import Logger from '../../../../Logger.js';
import { constants } from '../../../../constants/constants';

const appVars = AppVars.getInstance();
const errorClass = "errorMessage message__TO";

class ActivateFailureView extends React.Component {

    constructor(props){
        super(props);
        this.state = {
            ...props,

        }
    }

    render() {
        return(
            <div>
                {/* HEADER AND TITLE RENDERING BASED ON STATE */}
                <div role = "banner">
                    <Image className="login-log-resend" src={ToyotaLogo}/>
                </div>
                <div className="title__TO" style={{'marginBottom': '29px', 'marginTop': '124px', 'width':'auto', justifyContent:'center'}}>
                    {constants.ACTIVATE_FAIL_TITLE}
                </div>

                {/* BODY OF THE COMPONENT */}
                <div className="body-container__TO">
                    <div className="">
                                                 {/* FAILED ACTIVATION */}
                        <div className="">
                            {/* First time - the activation email has not been resent yet */}
                            <div style={{'marginBottom' : '15px'}} className={`message__TO ${(!this.props.resendSuccess) && (!this.props.resendFailure) ? "block": "none"}`}>Please try again.</div>

                            {/* Sent an email, rendering the proper elements based on different scenarios */}
                            <div className={`${this.props.resendSuccess === true ? "error itemLevel" : "none"}`}>
                                <p className={`${this.props.resendEmailSent === true ? "successMessage message__TO": "none"}`} role="alert" aria-live="polite">Email has been sent to {this.props.email}.</p>
                                <p className={`${this.props.userAlreadyActivated === true ? errorClass : "none"}`} role="alert" aria-live="polite">The email address you provided is linked to an existing account. Try signing in with that email, or provide a different email address.</p>
                            </div>
                            <div className={`${this.props.resendFailure === true ? "error itemLevel" : "none"}`}>
                                <p className={`${this.props.resendEmailFail === true ? errorClass : "none"}`} role="alert" aria-live="polite">We were not able to activate your account. Please try again.</p>
                                <p className={`${this.props.userNotFound === true ? errorClass : "none"}`} role="alert" aria-live="polite">We were not able to activate your account. Please check that your email address is correct and try again.</p>
                            </div>
                            <Form id='activateEmail__TO' noValidate validated = {this.props.isFormValid} onSubmit={this.props.sendNewEmailActivation}>
                                <Form.Group className = "relative">
                                <Form.Label className = {`${this.props.onFocus === false ? "absolute floating-label" : "absolute inline-label" }
                                ${this.props.onFocus === true ? "label-black__TO" : "" }
                                ${this.props.isFormValid === false ? "label-red__TO" : ""}
                                `}>
                            Email
                            <span id="redStar">*</span></Form.Label>
                                <Form.Control
                                    id='email__TO'
                                    data-testid='email'
                                    aria-label='Email'
                                    as='input'
                                    type='text'
                                    name='email'
                                    value = {this.props.email}
                                    onChange = {this.props.handleEmailChange}
                                    onFocus = {this.props.setFocus}
                                    onBlur = {this.props.removeFocus}
                                    bsPrefix = {`${this.props.isFormValid === false ? "highlight-error__TO form-control" : ""}`}
                                />
                        </Form.Group>
                                    <div
                                        id = "emailValidationAlert"
                                        data-testid = "emailValidationError"  
                                        className = {`logon-item-error__TO ${this.props.isFormValid === false ? "block" : "none"}`}
                                        role = "alert" 
                                        aria-hidden = {`${this.props.isFormValid === false ? "false" : "true"}`}
                                    >
                                            Please enter a valid email address
                                    </div>
                                <Button style = {{"marginTop" : "30px"}} id='resend-button' data-testid = "activateEmailButton" bsPrefix = "button__TO" type = "submit" >Resend Activation Email</Button>
                                </Form>
                            {/* <ResendLink
                                lineText="Already have a Toyota account?"
                                linkAddress="/"
                                linkText="SIGN IN"
                                className="resend-link"
                            />
                            <ResendLink
                                lineText="Need help?"
                                linkAddress="https://www.toyota.com/support/contact-us"
                                linkText="CONTACT US"
                                className="resend-link"
                            /> */}
                        </div>
                    </div>
                </div>
                <div className={`${this.props.loadingResend === true ? "resend-background" : "none" }`}>
                    <div className="spinner">
                    <img className='spinner-img' src={Loader} />
                    </div>
                </div>
            </div>
        )
    }

   
}

export default ActivateFailureView